import { Col, Empty, Form, Input, Row, Select, Typography } from 'antd'
import React, { useEffect, useState, useImperativeHandle } from 'react'
import { useRef } from 'react'

const ConverToUserForm = ({ form }) => {
    const [timezones, setTimezones] = useState([])
    const [timeZoneChange, setTimeZoneChange] = useState('')
    const [suggestions, setSuggestions] = useState([])
    const { Text } = Typography
    const sessionTokenRef = useRef()
    const timeoutRef = useRef()
    const { Option } = Select
    useEffect(() => {
        const aryIanaTimeZones = Intl.supportedValuesOf('timeZone')

        const newData = aryIanaTimeZones.map((timeZone) => {
            const date = new Date()
            const formatter = new Intl.DateTimeFormat('en-US', {
                timeZone,
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                timeZoneName: 'shortOffset',
                hour12: false,
            })

            const parts = formatter.formatToParts(date)
            const timeZoneOffset = parts.find(
                (part) => part.type === 'timeZoneName'
            ).value

            return {
                label: `${timeZone}`,
                value: `UTC${timeZoneOffset.replace('GMT', '')} ${timeZone}`,
                offset: `UTC${timeZoneOffset.replace('GMT', '')}`,
            }
        })

        setTimezones(newData)
    }, [])
    const loadSuggestions = async (inputValue) => {
        clearTimeout(timeoutRef.current)

        if (!inputValue || inputValue.trim().length <= 1) {
            setSuggestions([])
            return
        }

        timeoutRef.current = setTimeout(async () => {
            if (!sessionTokenRef.current) {
                sessionTokenRef.current =
                    new window.google.maps.places.AutocompleteSessionToken()
            }

            const placesService = new window.google.maps.places.PlacesService(
                document.createElement('div')
            )
            new window.google.maps.places.AutocompleteService().getPlacePredictions(
                {
                    input: inputValue,
                    sessionToken: sessionTokenRef.current,
                },
                async (predictions, status) => {
                    if (
                        status ===
                        window.google.maps.places.PlacesServiceStatus
                            .ZERO_RESULTS
                    ) {
                        setSuggestions([])
                        return
                    }
                    if (
                        status !==
                        window.google.maps.places.PlacesServiceStatus.OK ||
                        !predictions
                    ) {
                        return
                    }

                    const newData = []

                    for (const predictionData of predictions) {
                        const placeId = predictionData?.place_id

                        const placeData = await new Promise(
                            (resolve, reject) => {
                                placesService.getDetails(
                                    { placeId, fields: ['geometry'] },
                                    async (place, status) => {
                                        if (
                                            status ===
                                            window.google.maps.places
                                                .PlacesServiceStatus.OK &&
                                            place &&
                                            place.geometry &&
                                            place.geometry.location
                                        ) {
                                            const location =
                                                place.geometry.location

                                            try {
                                                const response = await fetch(
                                                    `https://maps.googleapis.com/maps/api/timezone/json?location=${location.lat()},${location.lng()}&timestamp=${Math.floor(
                                                        Date.now() / 1000
                                                    )}&key=AIzaSyC79hoAq6x6PIprpy39EPylaZ6i6ZVEsD4`
                                                )

                                                if (!response.ok) {
                                                    throw new Error(
                                                        `HTTP error! Status: ${response.status}`
                                                    )
                                                }

                                                const data =
                                                    await response.json()
                                                const timeZoneId =
                                                    data.timeZoneId

                                                resolve({
                                                    label: predictionData?.description,
                                                    value: predictionData?.description,
                                                    timeZone: timeZoneId,
                                                })
                                            } catch (error) {
                                                console.error(
                                                    'Error fetching timezone data:',
                                                    error
                                                )
                                                reject(error)
                                            }
                                        } else {
                                            console.error(
                                                'Error getting place details:',
                                                status
                                            )
                                            reject(status)
                                        }
                                    }
                                )
                            }
                        )
                        newData.push(placeData)
                    }

                    setSuggestions(newData)
                }
            )
        }, 350)
    }

    return (
        <div>
            <Form
                form={form}
                layout="vertical"
                style={{ marginTop: 10 }}
                autoComplete="off"
            >
                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        { required: true, message: 'Please enter email' },
                        // {
                        //     validator: (_, value) => {
                        //         const fullEmail = value?.endsWith('@softwareco.com')
                        //             ? value
                        //             : `${value}@softwareco.com`;

                        //         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        //         if (emailRegex.test(fullEmail)) {
                        //             return Promise.resolve();
                        //         }
                        //         return Promise.reject(new Error('Enter a valid @softwareco.com email'));
                        //     },
                        // },
                    ]}
                    style={{ marginBottom: '12px' }}
                >
                    <Input
                        placeholder="Enter email (without domain)"
                        autoComplete="off"
                        addonAfter="@softwareco.com"
                        onChange={(e) => {
                            let input = e.target.value;
                            // Strip domain if typed manually
                            if (input.includes('@')) {
                                input = input.split('@')[0];
                            }
                            form.setFieldsValue({ email: input });
                        }}
                        // onBlur={() => {
                        //     const nameOnly = form.getFieldValue('email');
                        //     if (nameOnly && !nameOnly.endsWith('@softwareco.com')) {
                        //         form.setFieldsValue({
                        //             email: `${nameOnly}@softwareco.com`,
                        //         });
                        //     }
                        // }}
                        value={
                            form.getFieldValue('email')?.replace('@softwareco.com', '') || ''
                        }
                    />
                </Form.Item>


                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter password',
                                },
                            ]}
                            style={{ marginBottom: '12px' }}
                        >
                            <Input.Password
                                placeholder="Enter password"
                                autoComplete="off"
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Confirm Password"
                            name="confirmPassword"
                            dependencies={['password']}
                            style={{ marginBottom: '12px' }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please confirm password',
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (
                                            !value ||
                                            getFieldValue('password') === value
                                        ) {
                                            return Promise.resolve()
                                        }
                                        return Promise.reject(
                                            new Error('Passwords do not match')
                                        )
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                placeholder="Confirm password"
                                autoComplete="off"
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>

                        <Form.Item
                            label="Timezone"
                            name="timeZone"
                            colon={false}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Enter Timezone',
                                },
                            ]}
                        >
                            <Select showSearch placeholder="Enter Timezone">
                                {timezones?.length > 0 &&
                                    timezones.map((data) => (
                                        <Option key={data?.value}>
                                            <Row
                                                align={'middle'}
                                                style={{
                                                    columnGap: '8px',
                                                }}
                                            >
                                                <Text>({data?.offset})</Text>
                                                <Text>{data?.label}</Text>
                                            </Row>
                                        </Option>
                                    ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Location*"
                            name="location"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Select Location',
                                },
                            ]}
                            colon={false}
                        >
                            <Select
                                placeholder="Search a Location"
                                allowClear={false}
                                onSelect={(_, option) =>
                                    setTimeZoneChange(option?.key)
                                }
                                notFoundContent={
                                    <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No Locations Searched"
                                    ></Empty>
                                }
                                onSearch={(value) => {
                                    loadSuggestions(value)
                                }}
                                showSearch
                            >
                                {suggestions?.length > 0 &&
                                    suggestions.map((option) => (
                                        <Option
                                            key={option?.timeZone}
                                            value={option?.label}
                                        >
                                            <Text>{option?.label}</Text>
                                            &nbsp;
                                            <Text>({option?.timeZone})</Text>
                                        </Option>
                                    ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default ConverToUserForm
